// Diner-side "favorites" shortlist: dishes the guest stars while browsing so they
// can compare them later in one place. Stored as full item objects (mirroring how
// featuredItems/popular are passed around) so the favorites screen can render the
// same MenuItem card without re-fetching. Persisted via the root vuex-persistedstate
// (sessionStorage) — clears when the tab closes, matching the cart's lifetime.
export default {
    namespaced: true,
    state: () => {
        return {
            items: [],
        };
    },
    mutations: {
        ADD_FAVORITE(state, item) {
            if (!state.items.some(i => i.id === item.id)) {
                state.items.push(item);
            }
        },
        REMOVE_FAVORITE(state, itemId) {
            state.items = state.items.filter(i => i.id !== itemId);
        },
        CLEAR_FAVORITES(state) {
            state.items = [];
        },
    },
    getters: {
        getFavorites: state => state.items,
        getCount: state => state.items.length,
        isFavorite: state => itemId => state.items.some(i => i.id === itemId),
    },
};
